import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjsUtils from '@attain-apps/rxjs-utils'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * When a preview request is made, plugin attempts to execute the API request,
 * and send out the appropriate success or error action afterwards
 */
export const getPreviewOnRequest = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.preview.request.observe().pipe(
      rxjsUtils.latestFrom(action => ({
        action: rxjs.of(action),
        context: plugin.collection.feature.selectors.context.asObservable,
      })),
      rxjs.mergeMap(({ action, context }) => {
        const { flexibleIdentifier, query } = action.data
        // We get the raw preview using the API
        const rawPreview$ = plugin.api.preview(context, {
          flexibleIdentifier,
          query,
        })
        // TODO: after the first response, everything else should be a follow
        // up success or follow up error
        return rawPreview$.pipe(
          // Handles success
          rxjs.map(rawPreview =>
            feature.actions.preview.success.from(action).create({
              request: action.data,
              response: {
                rawPreview,
              },
            }),
          ),
          // Handles error
          rxjs.catchError(error =>
            rxjs.of(
              feature.actions.preview.error.from(action).create({
                error,
                request: action.data,
              }),
            ),
          ),
        )
      }),
    ),
)
